import React from "react";
import InputMask from "react-input-mask";

interface PhoneNumberInputProps {
  label?: string;
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  errorMessage?: string;
  countryCode: "IN" | "US"; // Specify the country code (India or US)
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value = "",
  onChange,
  placeholder,
  countryCode,
}) => {
  // Define masks for different country codes
  const phoneMask = countryCode === "IN" ? "99999-99999" : "(999) 999-9999";
  const defaultPlaceholder =
    countryCode === "IN" ? "12345-67890" : "(123) 456-7890";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <InputMask
      mask={phoneMask}
      value={value}
      onChange={handleChange}
      required
      placeholder={placeholder || defaultPlaceholder}
      className={`hl-input w-full leading-none`}
    />
  );
};

export default PhoneNumberInput;
